import DocumentDescription from './DocumentDescription.vue';

export default DocumentDescription;
